// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"462":"e5b4b203","659":"e5b4b203"}[chunkId] + ".chunk.css";
};